import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Button from '../../../../components/button'

import image from './economic-overview-with-banner.png'
import styles from './hero.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'Automatisera din bokföring med Dooer',
    id: 'landingPage.hero.heading',
  },
  lede: {
    defaultMessage:
      'Gratis bokföringsprogram.{linebreak}Hantera din bokföring, fakturering och lön på ett ställe. Designat för dig som företagare, kraftfullt, enkelt och gratis.',
    id: 'landingPage.hero.lede',
  },
  button: {
    defaultMessage: 'Kom igång - det är gratis',
    id: 'landingPage.hero.button',
  },
})

const Hero: React.FC<{ cta: () => void }> = ({ cta }) => {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <div className={styles.left}>
            <h1 className={styles.heading}>
              <FormattedHTMLMessage {...messages.heading} />
            </h1>
            <p className={styles.lede}>
              <FormattedMessage
                {...messages.lede}
                values={{
                  linebreak: <br />,
                }}
              />
            </p>

            <div className={styles.buttonWrapper}>
              <Button bankId onClick={() => cta()} variant="success">
                <FormattedHTMLMessage {...messages.button} />
              </Button>
            </div>
          </div>

          <div className={styles.imageWrapper}>
            <img alt="Dooer" className={styles.productImage} src={image} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
